(function ($) {
    $.fn.circleGraph = function () {

        this.each((index, element) => {

            const $self = $(element);
            const $graphContainer = $self;
            const $outerCircles = $graphContainer.find('.outer-circle');
            let outerCircleMinWidth = 125, outerCircleMaxWidth = 400, circleWidthMinPercentage = 35, circleWidthMaxPercentage = 70;
            let availableWidth, oneCountWidth;

            function init() {
                // Calculate available space in right and set width and padding of slider accordingly
                let centerCircleWidth = $graphContainer.find('.circle-of-total').outerWidth();
                outerCircleMinWidth = ( centerCircleWidth / 100 ) * circleWidthMinPercentage;
                outerCircleMaxWidth = ( centerCircleWidth / 100 ) * circleWidthMaxPercentage;
                availableWidth = outerCircleMaxWidth - outerCircleMinWidth;
                oneCountWidth = availableWidth / 100;

                $outerCircles.each((index, circle) => {
                    let circlePercentage = $(circle).attr('data-percentage');
                    let circleWidth = (outerCircleMinWidth + (oneCountWidth * circlePercentage)) +'px';
                    $(circle).css({'width': circleWidth, 'height': circleWidth});
                });

            }

            function addEventHandler() {
                $outerCircles.on('mouseenter', (e) => {
                    let circle = $(e.target).parents('.outer-circle');

                    // If circle not found
                    if(!circle) return;

                    // Add hover 
                    $('.outer-circle[data-id="'+$(circle).attr('data-id')+'"]').addClass('hover');
                });

                $outerCircles.on('mouseleave', (e) => {
                    let circle = $(e.target).parents('.outer-circle');
                    
                    // If circle not found
                    if(!circle) return;

                    // Remove hover 
                    $('.outer-circle[data-id="'+$(circle).attr('data-id')+'"]').removeClass('hover');
                });
            }

            // On window resize
            $(window).on('resize', () => {
                setTimeout(() => { init(); }, 1100);
            });

            init();
            addEventHandler();
        });


        return this;
    }

    $(() => {
        $('.circle-graph').circleGraph();
    })

})($);




// WEBPACK FOOTER //
// ./scripts/components/circle-graph.js